import type { ThematicBreak } from 'mdast';

import type { State } from '../state';

export function thematicBreak(state: State, _node: ThematicBreak): void {
	const nodeType =
		state.schema.nodes.horizontal_rule ?? state.schema.nodes.rule ?? state.schema.nodes.hr;
	if (!nodeType) {
		// Gracefully degrade: schema has no rule node — skip the thematic break
		return;
	}
	state.addNode(nodeType, null, []);
}
